import * as z from "zod/v4";

export const duplicateCampaign = {
  name: "duplicateCampaign" as const,
  input: z.object({ id: z.string(), name: z.string() }),
  output: z.null(),
};
